import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { RECORDING_REQUIREMENTS_ACTION_TYPE } from '../actions';

const initialState = {
  scopes: [],
  effective: null,
};

const recordingRequirementsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case RECORDING_REQUIREMENTS_ACTION_TYPE.GET_SCOPES:
        draft.scopes = payload;
        break;

      case RECORDING_REQUIREMENTS_ACTION_TYPE.GET_EFFECTIVE:
        draft.effective = payload;
        break;

      case RECORDING_REQUIREMENTS_ACTION_TYPE.CLEAR_EFFECTIVE:
        draft.effective = null;
        break;

      case RESET_STATE:
      case RECORDING_REQUIREMENTS_ACTION_TYPE.RESET_RECORDING_REQUIREMENTS_STATE:
        return initialState;

      default:
        break;
    }
  });

export default recordingRequirementsReducer;
